import { monthNames } from "./enum";

export const formatMonths = (monthsRaw) => {
    if (!monthsRaw) return "";
    if (typeof monthsRaw === "string") {
        const [year, month] = monthsRaw.split("-");
        return `${monthNames[parseInt(month, 10) - 1]} ${year}`;
    }
    if (Array.isArray(monthsRaw)) {
        return monthsRaw.map(m => {
            const [year, month] = m.split("-");
            return `${monthNames[parseInt(month, 10) - 1]} ${year}`;
        });
    }
    return "";
};
